import { filter } from "lodash";
import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import moment from 'moment';

import { useSelector } from "react-redux";

import { Link, useHistory, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { getSellProductDetail, postBuyUpdate } from "../../crud/auth.crud"
import Modal from "components/RopikCustom/Modal";
import Modal2 from "components/RopikCustom/Modal_v2";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import FileUploads from "../../components/RopikCustom/FileUploads";
import Util from "pages/Dashboard/Common/Util";

// import images
import Default from "assets/images/default.png";

import Loading from "pages/Custom/Loading";

const selectedClass = 'secondary-bg white-text border-none'
const unselectedClass = 'button-border secondary-text white-bg'

const subjectToRecyclingArr = [
  { 'key': 'compost', 'text': '퇴비' },
  { 'key': 'feed', 'text': '사료' },
  { 'key': 'wasteoil', 'text': '폐유' },
]

const SellRequestUpdate = () => {
  const selector = useSelector(state => state)
  const history = useHistory()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const id = queryParams.get('id')

  const [imgArr, setImgArr] = useState([]);
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [subjectToRecycling, setSubjectToRecycling] = useState('compost');
  const [modalShow, setModalShow] = useState(false);
  const [alertModalShow, setAlertModalShow] = useState(false);
  const [onUpload, setOnUpload] = useState(false);
  const [pricePerKg, setPricePerKg] = useState(0);
  const [qty, setQty] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [previewImages, setPreviewImages] = useState([])
  const [selectedItem , setSelectedItem] = useState(null)
  const [deletedFiles, setDeletedFiles] = useState([])

  const getData = async () => {
    const response = await getSellProductDetail(id);
    if (response.status === 200) {
      const data = response.data
      setSubject(data.subject)
      setContent(data.content)
      setSubjectToRecycling(data.product_type)
      setPricePerKg(data.price_per_kg)
      setQty(data.qty)
      setImgArr(data.trade_file)
      setPreviewImages(data.trade_file)
      console.log(response.data)
    }
  }

  const modalOpen = (item) => {
    setSelectedItem(item)
    setModalShow(true)
  }

  const modalClose = () => {
    setModalShow(false);
  }

  const handleWrite = async () => {
    setOnUpload(true)

    try {
      const fd = new FormData();

      for (let i = 0; i < imgArr.length; i++) {
        if (!imgArr[i]?.id) {
          fd.append('file_' + i, imgArr[i])
        }
      }

      const companyData = selector.auth?.user?.member_group?.[0]?.company_group;
      const member = selector.auth?.user;
      const tradeData = {
        id: id,
        company: companyData?.id,
        member: member.id,
        address: companyData.address1 + ' ' + companyData.address2 || '',
        subject: subject,
        content: content,
        product_type: subjectToRecycling,
        price_per_kg: parseInt(pricePerKg),
        qty: parseInt(qty),
        type: 'sell',
        state: 'N',
        status: 'Y',
      }
      fd.append('trade_data', JSON.stringify(tradeData))

      fd.append('deleted_file_data', JSON.stringify(deletedFiles))

      const response = await postBuyUpdate(fd);
      if (response.data?.result === 'success') {
        setOnUpload(false)
        alert(response.data.msg)
        history.goBack()
      } else {
        setOnUpload(false)
      }

    } catch (e) {
      setOnUpload(false)
      console.log(e)
    }
  }

  const deleteImage = (index) => {
    setImgArr(imgArr.filter((v, i) => { return i !== index; }))
    const deletedId = previewImages[index]?.id
    if (deletedId) {
      setDeletedFiles([...deletedFiles, deletedId])
    }
    setPreviewImages(previewImages.filter((v, i) => { return i !== index; }))
  }

  useEffect(() => {
    setTotalPrice(pricePerKg * qty)
  }, [pricePerKg, qty])

  const handleFileChange = (event) => {
    const files = event.target.files;
    let prevTmp = [...previewImages];
    for (let i = 0; i < files.length; i++) {
      let item = {
        name: files[i].name,
        path: URL.createObjectURL(files[i]),
      }
      prevTmp.push(item)
    }
    let tmp = [...imgArr, ...files];
    tmp = tmp.filter((v, i) => { return i - 5 < 0 })
    setImgArr(tmp)
    prevTmp = prevTmp.filter((v, i) => { return i - 5 < 0 })
    setPreviewImages(prevTmp);
  };

  useEffect(() => {
    getData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>상품 정보 수정 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Breadcrumbs maintitle="Home" breadcrumbItem="상품 정보 수정" />
          </Row>

          <Row style={{justifyContent: "center"}}>
            <Col xs="12" style={{ maxWidth: '51.5rem' }}>
              <div className="email-rightbar mb-3">
                <p style={{ width: 110, color: '#333', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>상품 정보 수정</p>
                <Card style={{border: '1px solid #D9D9D9', borderRadius: 0}}>
                  <CardBody style={{ padding: 24 }}>
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-15 padding-left-8 primary-bg white-text">상품명(제목)</td>
                          <td className="w-85" colSpan={3}>
                            <input className="waver-input-box font-size-12 w-100 border-radius-0 w-70" placeholder="상호명을 입력해 주세요." value={subject} onChange={(e) => {
                              setSubject(e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-15 padding-left-8 primary-bg white-text">상품종류</td>
                          <td className="w-85" colSpan={3}>
                            {subjectToRecyclingArr.map((item, index) => (
                              <button key={item.key + index} style={{ width: 38, height: 24 }} type="button" className={`border-radius-0 margin-right-4 font-size-11 line-height-1 ${subjectToRecycling === item.key ? selectedClass : unselectedClass}`} onClick={() => {
                                setSubjectToRecycling(item.key)
                              }}>
                                {item.text}
                              </button>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-15 padding-left-8 primary-bg white-text">상품이미지</td>
                          <td className="w-85" colSpan={3}>
                            <div className="d-flex align-items-start">
                            <input className="d-none" accept="image/*" type="file" multiple id="products" onChange={handleFileChange}/>
                            <label style={{width: 113}} htmlFor="products" type="button" className="custom-btn border-radius-0 tertiary-bg white-text mb-0 text-center margin-right-12">
                              파일선택({previewImages.length}/5)
                            </label>
                            {previewImages.map((item, index) => (
                              <div key={item.name} style={{width: 72, height: 72, position: 'relative', marginRight: 12}}>
                                <img style={{width: 72, height: 72}} src={item.id ? Util.replaceDomain(item.path) : item.path} />
                                <div 
                                  onClick={() => {modalOpen(item)}}
                                  onMouseOver={(e)=>{e.target.style.background='none'}} 
                                  onMouseOut={(e)=>{e.target.style.background='rgba(0, 0, 0, 0.3)'}}
                                  style={{position:'absolute', backgroundColor: 'rgba(0, 0, 0, 0.3)', width: 72, height: 72, top:0, left: 0, zIndex: 2, cursor:'pointer'}}
                                />
                                <div style={{position: "absolute", top: 6, right: 6, zIndex: 3, cursor: "pointer"}} onClick={() => {deleteImage(index)}}>
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                    <circle cx="7" cy="7" r="6.5" stroke="white" fill="none" />
                                    <path d="M5 5L9 9M9 5L5 9" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
                                  </svg>
                                </div>
                              </div>
                            ))}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-15 padding-left-8 primary-bg white-text">Kg당 가격 (원)</td>
                          <td className="w-35">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0 w-70" placeholder="가격을 입력해 주세요." value={pricePerKg === 0 ? '' : Util.setPrice(pricePerKg)} onChange={(e) => {
                              e.target.value.length == 0 ? setPricePerKg(0) : setPricePerKg(e.target.value.replace(/,/g, ''));
                            }} />
                          </td>
                          <td className="w-15 padding-left-8 primary-bg white-text">판매량 (Kg)</td>
                          <td className="w-35">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0 w-70" placeholder="판매량을 입력해 주세요." value={qty === 0 ? '' : Util.setPrice(qty)} onChange={(e) => {
                              e.target.value.length == 0 ? setQty(0) : setQty(e.target.value.replace(/,/g, ''));
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">상품 상세</td>
                          <td className="w-90 pb-0" colSpan={3}>
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="상품 상세를 입력해 주세요." value={content}
                            onChange={(e)=>{
                              setContent(e.target.value);
                            }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{textAlign: "end", fontWeight: 'bold', fontSize: 15, marginTop: 40, lineHeight: '100%', marginBottom: 0}}>총가격&nbsp;&nbsp;<span style={{fontSize: 20, color: '#DA0000'}}>{Util.setCommaPrice(totalPrice)}</span>&nbsp;원</p>
                  </CardBody>
                </Card>
                <div className="waver-pagination-btn-group d-flex justify-content-between">
                  <button style={{ width: 100, height: 35 }} type="button" className="border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none"  onClick={() => { history.goBack() }}>
                    돌아가기
                  </button>
                  <div className="d-flex">
                    <button style={{ width: 100, height: 35 }} type="button" className="border-radius-0 margin-right-4 font-size-11 line-height-1 primary-bg white-text border-none"  onClick={() => {
                      if (!subject) {
                        setAlertModalShow(true)
                        return
                      }
                      handleWrite()
                    }}>
                      상품수정
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {onUpload && <Loading />}

      <Modal title={'파일 미리보기'} show={modalShow} onHide={modalClose} size="md" onSubmit={()=>{}}>
        <div style={{ zIndex: 1, minHeight : '300px', width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column' }}>
          <p style={{fontSize: '1rem', textAlign: 'center'}}>{selectedItem?.name}</p>
          <img style={{
            margin: '0 auto',
            width: '90%',
          }}
          src={selectedItem?.id ? Util.replaceDomain(selectedItem?.path) : selectedItem?.path}
          onError={(e) => e.target.src = Default} />
        </div>
      </Modal>

      <Modal2
        title={'정보알림'}
        show={alertModalShow}
        onHide={() => {
          setAlertModalShow(false)
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>상품명(제목)이 입력되지 않았습니다.</p>
            <p>상품명(제목)을 입력해 주세요</p>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end">
            <button style={{ width: 'auto' }} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
              setAlertModalShow(false)
            }}>
              확인
            </button>
          </div>
        }
      >
      </Modal2>
    </React.Fragment>
  )
}

export default SellRequestUpdate
